module.exports = __webpack_public_path__ + "static/media/kibetradicionalmin.4a33300f.webp";